import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import Table from 'rc-table'
import { Divider } from '../../components'
import {
  Container,
  DeleteButton,
  FullWidth,
  Header,
  StyledButton,
  StyledButtonEnd,
  StyledHeader,
  StyledNumberLink,
  StyledPagination,
  StyledRow,
  StyledTable,
  TableWrapper,
  Title,
} from './styled'
import {
  deleteComplaintAction,
  getInaccuracyAction,
} from '../../store'
import { useTypedSelector } from '../../hooks'
import { TypedComplaint } from './types'
import { RoutesTree } from '../../router'
import moment from 'moment'
import { Redirect } from 'react-router-dom'
import { Log } from '../../utils'

const Inaccuracy: React.FC = () => {
  const [typedInaccuracy, setTypedInaccuracy] = useState<TypedComplaint[]>([])
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [paginationLimit, setPaginationLimit] = useState<number>(8)

  const dispatch = useDispatch()

  const { inaccuracy, inaccuracyTotal } = useTypedSelector(
    state => state.feedback,
  )
  const { user } = useTypedSelector(state => state.user)

  if (!user?.access?.inaccuracy) {
    return <Redirect to={RoutesTree.notFound.path} />
  }
  // eslint-disable-next-line
  useEffect(() => {
    const localValues = localStorage.getItem('inaccuracy') ?? ''
    const parseLocalValues = !!localValues ? JSON.parse(localValues) : ''
    // eslint-disable-next-line
    !!localValues
      ? (setCurrentPage(parseLocalValues.page),
        dispatch(
          getInaccuracyAction.request({
            page: parseLocalValues.page,
            limit: paginationLimit,
            authorization: '',
          }),
        ))
      : dispatch(
          getInaccuracyAction.request({
            page: currentPage,
            limit: paginationLimit,
            authorization: '',
          }),
        )
  }, [])

  const columns = [
    {
      title: 'Название',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Описание',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Клиника',
      dataIndex: 'clinic',
      key: 'clinic',
    },
    {
      title: 'Дата создания',
      dataIndex: 'createdAt',
      key: 'createdAt',
    },
    {
      title: '',
      dataIndex: 'delete',
      key: 'delete',
    },
  ]

  const choosePage = (page: number) => {
    localStorage.setItem(
      'inaccuracy',
      JSON.stringify({
        page: page === 0 ? 1 : page,
      }),
    )

    dispatch(
      getInaccuracyAction.request({
        page,
        limit: paginationLimit,
        authorization: '',
      }),
    )

    setCurrentPage(page)
  }

  const onPressDeleteInaccuracy = async (id: string) => {
    try {
      const result = window.confirm('Удалить неточность?')

      if (result) {
        dispatch(
          deleteComplaintAction({
            authorization: '',
            id,
          }),
        )

        setCurrentPage(1)
      }
    } catch (error) {
      Log.ruddy('Event: onPressDeleteInaccuracy')
    }
  }

  const data = () => {
    return inaccuracy?.map(inaccur => {
      return {
        title: (
          <StyledNumberLink to={{ pathname: `/inaccuracy/${inaccur?._id}` }}>
            {inaccur?.title ?? '-'}
          </StyledNumberLink>
        ),
        description: (
          <StyledNumberLink to={{ pathname: `/inaccuracy/${inaccur?._id}` }}>
            {inaccur?.description ?? '-'}
          </StyledNumberLink>
        ),
        clinic: (
          <StyledNumberLink to={{ pathname: `/inaccuracy/${inaccur?._id}` }}>
            {inaccur?.clinic?.Title ?? '-'}
          </StyledNumberLink>
        ),
        createdAt: (
          <StyledNumberLink to={{ pathname: `/complaint/${inaccur?._id}` }}>
            {moment(inaccur?.createdAt).isValid()
              ? moment(inaccur?.createdAt).format('HH:mm DD.MM.YYYY')
              : '-'}
          </StyledNumberLink>
        ),
        delete: (
          <DeleteButton onClick={() => onPressDeleteInaccuracy(inaccur?._id)}>
            Удалить
          </DeleteButton>
        ),
        key: inaccur?._id,
      }
    })
  }
  // eslint-disable-next-line
  useEffect(() => {
    setTypedInaccuracy(data())
  }, [inaccuracy])

  return (
    <Container>
      <div>
        <Header>
          <Title>Неточности ({inaccuracyTotal ?? 0})</Title>
        </Header>

        <Divider height={30} />

        <TableWrapper>
          <Table
            columns={columns}
            data={typedInaccuracy}
            scroll={{ y: 650 }}
            components={{
              body: {
                row: StyledRow,
              },
              header: {
                cell: StyledHeader,
              },
              table: StyledTable,
            }}
          />
        </TableWrapper>

        <Divider height={20} />
      </div>

      <FullWidth>
        <StyledPagination>
          {currentPage === 1 ? (
            <StyledButtonEnd>Назад</StyledButtonEnd>
          ) : (
            <StyledButton onClick={() => choosePage(currentPage - 1)}>
              Назад
            </StyledButton>
          )}

          <div>
            {currentPage}/
            {Math.ceil(inaccuracyTotal / paginationLimit) === 0
              ? 1
              : Math.ceil(inaccuracyTotal / paginationLimit)}
          </div>

          {currentPage ===
          (inaccuracyTotal === 0
            ? 1
            : Math.ceil(inaccuracyTotal / paginationLimit)) ? (
            <StyledButtonEnd>Далее</StyledButtonEnd>
          ) : (
            <StyledButton onClick={() => choosePage(currentPage + 1)}>
              Далее
            </StyledButton>
          )}
        </StyledPagination>
        <Divider height={10} />
      </FullWidth>
    </Container>
  )
}

export default Inaccuracy
